export const StudentDashboardCardJson = [
  {
    title: 'Avg Pre Score',
    value: 'avgPreScore',
  },
  ...Array.from({ length: 8 }).map((_, i) => ({
    title: `Exam${i + 1} Avg`,
    value: `avgExam${i + 1}Score`,
  })),
  {
    title: 'Avg Post Score',
    value: 'avgPostScore',
  },
  {
    title: 'Impact Reports Ready',
    value: 'impactReportsReady',
    noPercentage: true,
  },
];
